module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hant/4/2-37b8ec796a9fa6cfdc92dfe9d572059f.jpg";